<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <el-row type="flex" :gutter="10">
      <el-col :span="3">
        <el-input placeholder="标题" v-model="seachDm.Title"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="getReportMain(1)">查询</el-button>
        <el-button type="primary" @click="handleAdd()">新增</el-button>
      </el-col>
    </el-row>
    <!--列表-->
    <el-table
      :data="ReportMain"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
      height="600"
      :border="true"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="Title" label="标题" sortable></el-table-column>
      <el-table-column prop="Id" label="Id" sortable></el-table-column>
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        :formatter="formatDate"
        sortable
      ></el-table-column>
      <el-table-column
        prop="CreateUser"
        label="创建者"
        sortable
      ></el-table-column>
      <el-table-column prop="Remark" label="备注" sortable></el-table-column>
      <el-table-column prop="Status" label="状态" width="" sortable>
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Status == 0 ? 'success' : 'info'"
            disable-transitions
          >
            {{ scope.row.Status == 0 ? "正常" : "归档" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="ItemType" label="打印类型" width="" sortable>
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.ItemType == 0 ? 'success' : 'info'"
            disable-transitions
          >
            {{ scope.row.ItemType == 0 ? "Grid内容" : "Grid文件" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link
            v-if="canEdit"
            type="primary"
            @click="
              () => {
                currentRow = scope.row;
                handleEdit();
              }
            "
          >
            编辑
          </el-link>
          <el-link
            v-if="canDelete"
            type="danger"
            @click="
              () => {
                sels.push(scope.row);
                handleDel();
              }
            "
          >
            删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      layout="total, sizes, prev, pager, next, jumper"
      :page-size="pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      class="my-pagination"
    ></el-pagination>

    <!--编辑界面-->
    <el-dialog
      :title="IsEdit ? '新增' : '编辑'"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        :rules="editFormRules"
        ref="editForm"
      >
        <!-- <el-form-item label="内容" prop="Content">
          <div id="article_editor">
            <editor v-bind:content="editForm.Content"></editor>
          </div>
        </el-form-item> -->
        <el-form-item label="标题" prop="Title">
          <el-input v-model="editForm.Title" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="报表"
          prop="Content"
          v-show="editForm.ItemType == 100 ? false : true"
        >
          <el-input
            type="textarea"
            v-model="editForm.Content"
            auto-complete="off"
            style="height: 150px"
            :autosize="{ minRows: 2, maxRows: 9 }"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input
            type="textarea"
            v-model="editForm.Remark"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="打印服务地址" prop="PrintServiceUrl">
          <el-input
            v-model="editForm.PrintServiceUrl"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-select v-model="editForm.Status" placeholder="请选择状态">
            <el-option label="正常" :value="0"></el-option>
            <el-option label="归档" :value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板类型" prop="ItemType">
          <el-select v-model="editForm.ItemType" placeholder="请选择类型">
            <el-option label="Grid模板内容" :value="0"></el-option>
            <el-option label="Grid上传文件" :value="100"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="editForm.ItemType == 100 ? true : false">
          <el-upload
            class="upload-demo"
            :action="uploadFile.uploadUrl"
            :multiple="false"
            :drag="true"
            :file-list="uploadFile.fileList"
            :on-success="uploadCallBack"
            :on-error="uploadCallBack"
            :on-preview="DownBmdCallBack"
            :on-remove="removeFile"
            :limit="1"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
        >
          提交
        </el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { BaseApiUrl } from "../../api/api";
import * as api from "../../api/reportMain";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

import Editor from "../../components/Editor";
export default {
  name: "article_editor",
  components: { Toolbar, Editor },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      seachDm: {
        Title: "",
      },
      ReportMain: [],
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      sels: [], //列表选中列
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        Name: [{ required: true, message: "请输入标题", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        Name: "",
        Remark: "",
        Status: 0,
        ItemType: 0,
      },
      visibleDialog: false,
      IsEdit: false,
      uploadFile: {
        fileList: [],
        uploadUrl: `${BaseApiUrl}/api/Upload/Uploadfile`,
      },
    };
  },
  computed: {
    //计算属性,判断是否有权编辑
    canEdit() {
      let index = this.buttonList.findIndex((s) => s.name === "编辑");
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canDelete() {
      let index = this.buttonList.findIndex((s) => s.name === "删除");
      return index > -1;
    },
  },
  methods: {
    uploadCallBack(data) {
      this.uploadFile.fileList.push({
        name: data.response.split("\\")[1],
        url: data.response,
      });
    },
    DownBmdCallBack(data) {
      let fileName = "";
      let dataName = "";
      if (data && data.response && data.response.response) {
        fileName = data.response.response;
        dataName = decodeURI(data.config.params.filename);
      } else {
        fileName = data.url;
        dataName = data.name;
      }
      let para = {
        filename: fileName,
      };
      api.getFile(para).then((res) => {
        // 如果后端用encodeURI对文件名进行了编码，前端需用decodeURI进行解码（主要为处理特殊字符）
        //let fileName = decodeURI(data.headers.filename); // 由于ie不支持download属性，故需要做兼容判断
        let fileName = dataName; // 由于ie不支持download属性，故需要做兼容判断
        // let fileName = decodeURI(res.headers.filename); // 由于ie不支持download属性，故需要做兼容判断

        if (navigator.appVersion.toString().indexOf(".NET") > 0) {
          // ie独有的msSaveBlob属性，data.data为Blob文件流
          window.navigator.msSaveBlob(res.data, fileName);
        } else {
          let url = window.URL.createObjectURL(res.data);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
      });
    },
    removeFile(data) {
      this.uploadFile.fileList.splice(
        this.uploadFile.fileList.indexOf(data),
        1
      );
    },
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getReportMain();
    },
    //获取客户列表
    getReportMain(optype) {
      if (optype == 1) {
        this.page = 1;
      }
      let para = {
        page: this.page,
        Title: this.seachDm.Title,
        intPageSize: this.pageSize,
      };
      this.listLoading = true;
      api.getReportMainListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.ReportMain = res.data.response.data;
        this.listLoading = false;

        this.currentRow = null;
        this.sels = [];
      });
    },
    //执行删除
    handleDel() {
      let that = this;
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });
        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = that.sels.map((item) => item.Id);

          api.batchDeleteReportMain(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getReportMain();
          });
        })
        .catch(() => {})
        .finally(() => {
          this.listLoading = false;
        });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.IsEdit = true;
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      if (this.editForm.UploadUrl.length > 0) {
        var UploadUrls = this.editForm.UploadUrl;
        this.uploadFile.fileList = JSON.parse(UploadUrls);
      }
    },
    //显示新增界面
    handleAdd() {
      this.IsEdit = false;
      this.editFormVisible = true;
      this.editForm = { ItemType: 0, Status: 0 };
    },
    //执行编辑
    editSubmit() {
      if (this.uploadFile.fileList) {
        this.editForm.UploadUrl = JSON.stringify(this.uploadFile.fileList);
      }

      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;

            let para = Object.assign({}, this.editForm);
            let user = JSON.parse(window.localStorage.user);
            if (user && user.uID > 0) {
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              this.$router.replace(
                this.$route.query.redirect ? this.$route.query.redirect : "/"
              );
            }
            if (this.IsEdit) {
              api
                .editReportMain(para)
                .then((res) => {
                  if (res && res.data && res.data.success) {
                    this.$message({
                      message: res.data.msg,
                      type: "success",
                    });
                    this.$refs["editForm"].resetFields();
                    this.editFormVisible = false;
                    this.getReportMain();
                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: "error",
                    });
                  }
                })
                .finally(() => {
                  this.editLoading = false;
                });
            } else {
              api
                .addReportMain(para)
                .then((res) => {
                  if (res && res.data && res.data.success) {
                    this.$message({
                      message: res.data.msg,
                      type: "success",
                    });
                    this.$refs["editForm"].resetFields();
                    this.editFormVisible = false;
                    this.getReportMain();
                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: "error",
                    });
                  }
                })
                .finally(() => {
                  this.addLoading = false;
                });
            }
          });
        }
      });
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.pageSize = size;
      this.getReportMain(1);
    },
    setVisible(val) {
      this.visibleDialog = val;
    },
  },
  mounted() {
    this.getReportMain();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style lang="less" scoped></style>
